import React from 'react';
import { TypographyH2, TypographyP } from '@/Components/shadcn';
import BackButton from './BackButton';
import UIStrings from '@/Utils/UIStrings';
import { useInvitationPageContext } from '../Contexts/InvitationPageContext';

const Header = (): React.JSX.Element => {
    const { recruitmentName } = useInvitationPageContext();
    return (
        <div className="flex flex-col items-start gap-2.5">
            <BackButton />
            <div className="flex flex-col gap-1">
                <TypographyH2>{`${UIStrings.AttractApplicants} ${UIStrings.For} ${recruitmentName}`}</TypographyH2>
                <TypographyP>{UIStrings.EasilyAttractTopApplicantsThrough}</TypographyP>
            </div>
        </div>
    );
};
export default Header;
